<template>
  <!--div class="table-container"-->
  <div class="debug">
    <h3>debugging Filter-table.vue:</h3>
    <p>currPage = {{currPage}}</p>
    <p>theLastPage = {{ theLastPage }}</p>
    <p>filtered.length = {{ filtered.length }}</p>
    <p>filtered first row = {{ filtered[0] }}</p>
    <p>search obj = {{ search }}</p>
    <p>displayData.length = {{ displayData.length }}</p>

  </div>
  <table class="container, myTable">
    <!-- <colspan>
      <col v-for="(val, key) in columnWidths" span="1" :width="val"></col>
    </colspan>-->
    <col v-for="(val, key) in columnWidths" :style="`width:${val}%;`" :key="key" />

    <thead v-if="display">
      <tr>
        <slot name="header">
          <th v-for="(field, key) in header" :key="key" :scope="'col'">
            <ColumnFilter
              v-model:searchText="search[field]"
              :column-name="field"
              @sortAsc="sortAscending"
              @sortDesc="sortDescending"
            ></ColumnFilter>
          </th>
        </slot>
      </tr>
    </thead>
    <tbody>
      <tr
        class="click-row"
        v-for="(item, index) in displayData"
        @click="$emit('rowClicked', item, index)"
        :key="index"
      >
        <slot>
          <td v-for="(col, key) in header" :key="key">
            <StatusBadges v-if="col == 'status'" :statusArr="item[col]"></StatusBadges>
            <span v-else>{{ item[col] }}</span>
          </td>
        </slot>
      </tr>
    </tbody>
  </table>

  <nav>
    <div>
      <a href="#" onclick="event.preventDefault()" @click="firstPage">&lt;&lt;</a>
      <a href="#" onclick="event.preventDefault()" @click="previousPage">&lt;</a>
      <input v-model="currPage" />/
      <input v-model="theLastPage" disabled readonly />
      <a href="#" onclick="event.preventDefault()" @click="nextPage">&gt;</a>
      <a href="#" onclick="event.preventDefault()" @click="lastPage">&gt;&gt;</a>
    </div>
    <p style="color: white">
      [displaying {{ filtered.length }} of {{ props.data.length }} records]
    </p>
    <div style="flex: flex-basis; flex-basis: auto">
      <!--button v-if="props.allowDownload" type="button" @click="downloadCsv">
        Download Filtered Data
      </button-->
      <!--button type="button" @click="downloadAllCsv">Download All Data</button>-->
    </div>
  </nav>

  <!--/div>-->
</template>

<script setup lang="ts">
//TODO add pagination to table
import { ref } from 'vue'
import ColumnFilter from './Column-filter.vue'
import StatusBadges from './Status-badges.vue'
import { useTablePagination } from '@/composables/Table-pagination'
import { useTableCsvDownload } from '@/composables/Table-csv-download'
import { useTableSorter } from '@/composables/Table-sorter'
//import { useAllCsvDownload } from '@/composables/All-csv-download';
//import { useProjectTableFilter } from '@/composables/Project-table-filter';
const display = ref(true)

const props = defineProps({
  header: Array<string>,
  data: Array<any>,
  // columns: Array,
  columnWidths: Array<number>,
  //allowDownload: { type: Boolean, default: false }
})

const filtered = defineModel('filtered')
const search = defineModel('search')
/*let searchJson={};
props.header?.forEach(col=>{
  searchJson[col]='';
})
const search = ref(searchJson);*/
//const filtered = ref(JSON.parse(JSON.stringify(props.data)));
//const tableData = ref(JSON.parse(JSON.stringify(props.data)));
//const { filtered } = useProjectTableFilter(props.data, search);
const { currPage, displayData, theLastPage, previousPage, nextPage, firstPage, lastPage } =
  useTablePagination(filtered)
//const { downloadCsv } = useTableCsvDownload(props.header, filtered)
//const { downloadAllCsv } = useAllCsvDownload(props.data);
const { sortAscending, sortDescending } = useTableSorter(filtered)

const emits = defineEmits(['rowClicked'])
</script>

<style lang="css" scoped>
table thead tr th,
:slotted(table thead tr th) {
  vertical-align: top;
  /* color:yellow;*/
}

table {
  display: block;
  table-layout: fixed;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}
.table-container {
  width: 80%;
  margin: auto;
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
}

nav {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

nav input {
  width: 4rem;
}

tbody tr {
  height: 2rem;
}

tbody td {
  /*display: inline-block;*/
  vertical-align: center;
  overflow: hidden;
}
/*
  col.table-col-10{
    width:10%;
  }
  col.table-col-20{
    width:20%;
  }
  col.table-col-30{
    width:30%;
  }*/

col {
  overflow: hidden;
  min-width: 5%;
}

:slotted(span),
:slotted(td) {
  color: black;
  /*min-width: 10%;*/
  /*min-width: 2rem;
    min-height: 2rem;
    max-height: 2rem;*/
  height: 2rem;
  overflow: hidden;
  white-space: nowrap;
}
/*
  table body tr td{
    min-height: 2rem;
    height: 2rem;
  }*/

/*
  td, :slotted(td){
    overflow-x: wrap;
    min-width: 10%;
    background-color: green;
  }*/

/*
button{
    color: white;
    font-size: 0.875rem;
    line-height: 1.25rem;
    height: 2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    margin-top: 0.75rem;
    background-color: rgb(14 165 233);
    border: 2px solid rgb(14 165 233);
    border-radius: 0.375rem;
    cursor: pointer;

}*/

button:hover {
  color: black;
}

button:active {
  border: 2px solid black;
}

a,
nav p {
  padding: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.75rem;
  color: white;
  font-weight: 500;
  text-decoration: none;
}

a:hover {
  color: black;
}
</style>
